export default "__VITE_ASSET__BdIig4ie__"